import StudentStatsSummary from './StudentStatsSummary';

export default StudentStatsSummary;
